<template>
  <section class="blog-two-grid-section">
    <a :href="shopifyData.secLink ? shopifyData.secLink : '#'">
      <div class="blog-two-grid-container">
        <div class="left-column">
          <a :href="shopifyData.leftImageLink ? shopifyData.leftImageLink : '#'">
            <img
              :src="shopifyData.imageLeft"
              :alt="shopifyData.imageLeft.alt || 'Left Image'"
              class="left_image image"
              loading="lazy"
              aria-hidden="true"
              aria-label="Left Image"
              width=""
              height=""
            />
            <p class="left_text" v-html="shopifyData.leftText" />
          </a>
        </div>
        <div class="right-column">
          <a :href="shopifyData.rightImageLink ? shopifyData.rightImageLink : '#'">
            <img
              :src="shopifyData.imageRight"
              :alt="shopifyData.imageRight.alt || 'Right Image'"
              class="right_image image"
              loading="lazy"
              aria-hidden="true"
              aria-label="Right Image"
              width=""
              height=""
            />
            <p class="right_text" v-html="shopifyData.rightText" />
          </a>
        </div>
      </div>
    </a>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.blog-two-grid-section {
  display: flex;
  justify-content: space-between;
}
.blog-two-grid-section a {
  display: block;
}

.blog-two-grid-container {
  display: flex;
}

.left-column img,
.right-column img {
  display: block;
  /* max-width: 720px; */
  width: 100%;
}

.left-column,
.right-column {
  position: relative;
}

.right_text,
.left_text {
  color: #fff;
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.48px;
}

.left-column p {
  position: absolute;
  left: 62px;
  bottom: 38px;
}

.right-column p {
  position: absolute;
  right: 62px;
  bottom: 38px;
}

@media (max-width: 767px) {
  .blog-two-grid-container {
    display: flex;
    flex-direction: column;
  }

  .left-column p {
    position: absolute;
    left: 10px;
    bottom: 38px;
  }

  .right-column p {
    position: absolute;
    left: 10px;
    bottom: 38px;
  }

  .right_text,
  .left_text {
    font-size: 20px;
  }
}
</style>
